import React from "react";
import { PROFESSIONS, professionSubjects } from "@/lib/subjects";

export function ProfessionSubjectSelect({ profession, subject, onChange, allowAll = false, testPrefix }) {
  const subjects = profession ? professionSubjects(profession) : [];
  return (
    <>
      <label className="adm-field"><span className="adm-label">Beruf</span>
        <select className="adm-input" data-testid={`${testPrefix}-profession-select`} value={profession}
          onChange={(e) => { const p = e.target.value; onChange(p, allowAll ? "" : professionSubjects(p)[0]?.id || ""); }}>
          {allowAll && <option value="">Alle Berufe</option>}
          {PROFESSIONS.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select></label>
      <label className="adm-field"><span className="adm-label">Fach</span>
        <select className="adm-input" data-testid={`${testPrefix}-subject-select`} value={subject} onChange={(e) => onChange(profession, e.target.value)} disabled={!profession}>
          {allowAll && <option value="">Alle Fächer</option>}
          {subjects.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select></label>
    </>
  );
}
